import { zollBaseURL } from '../../../services/api.service'
import { ZollAPIService } from '../../../services/zollApi.service'
import {
  IFetchPowerOnTimesRequest,
  IFetchPowerOnTimesResponse,
  IFetchEventsAndReportsRequest,
  IFetchEventsAndReportsResponse,
  IFetchReportImageRequest,
  IFetchReportImageResponse,
} from '../store/ekgImport.types'

const getPowerOnTimeListResultsUrl = `${zollBaseURL}/api/CloudEKG/power-on-times`
const getEventsAndReportsListResultsUrl = `${zollBaseURL}/api/CloudEKG/events-and-reports`
const getReportImageResultsUrl = `${zollBaseURL}/api/CloudEKG/report-image`

export class EKGImportService extends ZollAPIService {
  async fetchPowerOnTimes(data: IFetchPowerOnTimesRequest): Promise<IFetchPowerOnTimesResponse> {
    return this.postWithError(getPowerOnTimeListResultsUrl, data)
  }

  async fetchEventsAndReports(data: IFetchEventsAndReportsRequest): Promise<IFetchEventsAndReportsResponse> {
    return this.postWithError(getEventsAndReportsListResultsUrl, data)
  }

  async fetchReportImage(data: IFetchReportImageRequest): Promise<IFetchReportImageResponse> {
    return this.postWithError(getReportImageResultsUrl, data)
  }
}
